module.exports = __webpack_public_path__ + "img/avatar6.74b3a2c7.png";